<h1>Password Reset</h1>
<checkd-password-recovery (submit)="onSubmit($event)"></checkd-password-recovery>
